import React from "react";
import "./refund.css";
import { useEffect } from "react";

const RefundPolicy = () => {
    useEffect(() => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}, []);
  return (
    <div className="refund-wrapper">
      <div className="refund-container">

        <h1>Refund Policy</h1>
        <p className="effective-date">
          Effective Date: January 1, 2026
        </p>

        <p className="intro">
          At Forge Your Peak, we are committed to delivering high-quality 
          performance measurement and training services. This Refund Policy 
          outlines the conditions under which refunds may be granted.
        </p>

        <hr />

        {/* Section 1 */}
        <h2>1. Digital Products & Online Programs</h2>
        <p>
          Due to the digital nature of our services (including games, dashboards, 
          training programs, downloadable resources, and membership access), 
          all sales are generally considered final.
        </p>

        <div className="highlight-box">
          Once access to a digital product or membership has been granted, 
          refunds are typically not provided.
        </div>

        {/* Section 2 */}
        <h2>2. Exceptional Circumstances</h2>
        <p>Refund requests may be reviewed in exceptional cases such as:</p>
        <ul>
          <li>Duplicate payment or billing errors.</li>
          <li>Technical issues that prevent access and cannot be resolved.</li>
          <li>Accidental purchase (reported within 24 hours).</li>
        </ul>

        {/* Section 3 */}
        <h2>3. Subscription Services</h2>
        <p>If your membership includes recurring billing:</p>
        <ul>
          <li>You may cancel future renewals at any time before the next billing cycle.</li>
          <li>Refunds are not issued for partially used billing periods.</li>
        </ul>

        {/* Section 4 */}
        <h2>4. Live Events & Coaching</h2>
        <p>For live workshops, camps, or coaching programs:</p>
        <ul>
          <li>Cancellations made at least 48 hours before the event may qualify for partial refunds.</li>
          <li>Late cancellations or no-shows are non-refundable.</li>
        </ul>

        {/* Section 5 */}
        <h2>5. Processing Time</h2>
        <p>
          Approved refunds will be processed within 7–14 business days 
          to the original payment method.
        </p>

        {/* Section 6 */}
        <h2>6. Contact for Refund Requests</h2>
        <p>To request a refund, please contact:</p>
        <p className="email">support@forgeyourpeak.com</p>
        <p>
          Include your full name, email used for purchase, and reason for the request.
        </p>

      </div>
    </div>
  );
};

export default RefundPolicy;